<template>
  <v-container>
    <v-row justify="center">
      <v-col class="call-tabs">
        <v-data-table
          :headers="headers"
          :items="customerVM"
          @click:row="changeLink"
        />
      </v-col>
    </v-row>
    <v-row class="mt-5" justify="center">
      <audio ref="voiceMail" controls>
        <source :src="voicemailUrl" />
      </audio>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "VoicemailsTab",
  data() {
    return {
      voicemailUrl: null,
      headers: [
        {
          text: "Date",
          align: "center",
          value: "createdAt",
        },
        {
          text: "Record Url",
          value: "url",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      customerVM: "voicemails/customerVM",
      user: "auth/user",
    }),
  },
  methods: {
    ...mapActions({
      updateVoicemailNotification: "notifications/updateVoicemailNotification",
    }),
    changeLink(e) {
      this.voicemailUrl = e.url;
      this.$refs.voiceMail.load();

      if (this.user.role_id !== 1) {
        this.updateVoicemailNotification(e.id);
      }
    },
  },
};
</script>

<style>
</style>